module.exports = __webpack_public_path__ + "static/media/p2008hapsira.bf403ccb.jpg";